import React from "react";
import InfoPageLayout from "../components/shared/InfoPageLayout";
import { aboutEldooParagraphs } from "../content/aboutEldoo";

const AboutPage: React.FC = () => {
  return (
    <InfoPageLayout
      eyebrow="About Eldoo"
      title="About Us"
      variantClassName="info-page-layout--policy"
      sections={[
        {
          heading: "Welcome to Eldoo",
          paragraphs: aboutEldooParagraphs,
        },
      ]}
    />
  );
};

export default AboutPage;
